import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/propietarios/propietarios';
import PropietarioList from './Propietarios';


const ms2p = (state) => {
  return {
    ...state.propietarios,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(PropietarioList);
